import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ArrowDirection, ArrowPosition, CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'a[sd-navigation-arrow], button[sd-navigation-arrow]',
  templateUrl: './navigation-arrow.component.html',
  styleUrls: ['./navigation-arrow.component.scss'],
  imports: [IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorNavigationArrowComponent {
  /**
   * Направление стрелки
   */
  @Input() direction: ArrowDirection = ArrowDirection.Left;
  /**
   * Позиция стрелки (перед или после контента)
   */
  @Input() position: ArrowPosition = ArrowPosition.Before;

  iconType = CUSTOM_ICON_TYPE;

  @HostBinding('class')
  get classNames(): string[] {
    return [this.direction && `direction-${this.direction}`, this.position && `position-${this.position}`].filter(
      Boolean,
    );
  }
}
